import BaseApi from 'common/apiRequest/apis/BaseApi';
import { IResetPasswordUrlParams } from 'common/constants/Types';
import { Request } from '../apiConcentrator/User';
import APINames from '../APINames';

class AuthnApi extends BaseApi {
  public requestInstance = new Request(APINames.USER);

  // 获取重置密码链接的状态、用户名、密码策略等信息
  getResetPasswordInitialData(params: IResetPasswordUrlParams) {
    return this.requestInstance.post(['enterprise', 'password_reset_url_check'], params);
  }

  resetPwdByUrl(params: IResetPasswordUrlParams & { credential: string }) {
    return this.requestInstance.post(['enterprise', 'password:url_reset'], params);
  }
}
export default new AuthnApi();
